var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-account-edit',{attrs:{"userDetails":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }